export type EmployeeNameEn = { firstName?: string; lastName?: string };
export type EmployeeNamesByAlias = Record<string, EmployeeNameEn>;

export const buildEmployeeFullName = (alias: string, name?: EmployeeNameEn): string => {
  if (!name) return alias;
  const composed = `${name.firstName ?? ''} ${name.lastName ?? ''}`.trim();
  return composed || alias;
};

export const buildEmployeeLastNameFirst = (alias: string, name?: EmployeeNameEn): string => {
  if (!name) return alias;
  const composed = `${name.lastName ?? ''} ${name.firstName ?? ''}`.trim();
  return composed || alias;
};

export const buildEmployeeLastNameSortKey = (alias: string, name?: EmployeeNameEn): string => {
  const composed = `${name?.lastName ?? ''} ${name?.firstName ?? ''}`.trim();
  return (composed || alias || '').toLowerCase();
};
